// CreateInvoice.jsx
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  Row,
  Table,
  FormGroup,
} from "reactstrap";
import moment from "moment-timezone";
import { Checkbox, FormControlLabel, Tooltip } from "@mui/material";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import { IoDocumentAttachSharp } from "react-icons/io5";
import { FaQuestionCircle, FaRegEdit } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaEdit, FaPencilAlt, FaRegClipboard, FaRegFileAlt, FaPenFancy } from "react-icons/fa";
import {
  setInvoiceCreatedPackages,
  setInvoiceItemsToDisplay,
  setInvoiceOptions,
  setNewCreatedPackages,
  setNewItemsToDisplay,
  setNewOptions,
  setSelectedPackages,
  setSelectedPrice,
} from "../../../redux/slices/MsgSlice";
import uploadToS3 from "../../../utils/awsS3Upload";
import { toast } from "react-toastify";
import Editor from "react-simple-wysiwyg";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import DealFactors from "../../../pages/DashboardPages/ServicePages/ServicePackages/DealFactors";
import { orderInvoice } from "../Data3";
import "./invoice.css";

const Android12Switch = styled(Switch)(({ theme }) => ({
  padding: 7,
  "& .MuiSwitch-track": {
    borderRadius: 11,
    border: "3px solid #4caf50",
    backgroundColor: "#fff",
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
    },
    "&::before": { left: 12 },
    "&::after": { right: 12 },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    width: 16,
    height: 16,
    margin: 2,
    backgroundColor: "#4caf50",
  },
  "&.Mui-checked .MuiSwitch-thumb": { backgroundColor: "#4caf50" },
  "&.Mui-checked + .MuiSwitch-track": { backgroundColor: "#fff" },
  "&.Mui-disabled .MuiSwitch-thumb": { backgroundColor: "#9e9e9e" },
  "&.Mui-disabled + .MuiSwitch-track": { backgroundColor: "#e0e0e0" },
}));

const CreateInvoice = ({
  isOpen,
  toggleModal,
  viewType,
  setViewType,
  selectedInvoice,
}) => {
  const dispatch = useDispatch();
  const selectedConversation = useSelector(
    (state) => state.messages.selectedConvo
  );
  const {
    invoiceItemsToDisplay,
    invoiceCreatedPackages,
    invoiceOptions,
    newItemsToDisplay,
    newCreatedPackages,
    newOptions,
    selectedPackagePrice,
  } = useSelector((state) => state.messages);

  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;

  const [invoceData, setInvoceData] = useState({});
  const [checked, setChecked] = useState(false);
  const [contractCheck, setContractCheck] = useState([]);
  const [editType, setEditType] = useState("");
  const [editOpen, setEditOpen] = useState(false);
  const [initialDealPackage, setInitialDealPackage] = useState([]);
  const [initialdealdealItem, setinitialdealdealItem] = useState([]);
  const [initialdealdealItemCustom, setinitialdealdealItemCustom] = useState(
    []
  );
  const [collectInsurance, setcollectInsurance] = useState(false);
  const [editedPackageIndex, setEditedPackageIndex] = useState(null);
  const [initialdealserviceSelectType, setinitialdealserviceSelectType] =
    useState([]);
  const [
    initialdealserviceSelectTypeCustom,
    setinitialdealserviceSelectTypeCustom,
  ] = useState([]);
  const [details, setDetails] = useState({
    clientName: "",
    clientEmail: "",
    clientPhone: "",
    providerName: "",
    providerAddress: "",
    providerEmail: "",
    providerPhone: "",
  });
  const [events, setEvents] = useState([
    {
      eventDate: "",
      eventTime: "",
      eventType: "",
      eventLocation: "",
      totalGuestCount: "",
    },
  ]);
  const [eventSchedule, setEventSchedule] = useState([
    {
      title: "",
      engage: "",
      eventStart: "",
      eventEnd: "",
      handOver: "",
    },
  ]);
  const [paymentSchedule, setPaymentSchedule] = useState([
    { payment: "Booking Deposit", due: "", amount: "" },
    { payment: "In-Person Payment", due: "", amount: "" },
  ]);
  const [dealNote, setDealNote] = useState("");
  const [selectedContract, setSelectedContract] = useState({});
  const [pdfFile, setPdfFile] = useState("");
  const [insuranceFile, setInsuranceFile] = useState("");
  const [filePreview, setFilePreview] = useState(null);
  const [loading, setLoading] = useState(false);

  // Auto-fill 15% deposit
  useEffect(() => {
    if (selectedPackagePrice && paymentSchedule.length > 0) {
      const deposit = Math.round(selectedPackagePrice * 0.15);
      const balance = selectedPackagePrice - deposit;
      setPaymentSchedule((prev) => [
        {
          ...prev[0],
          amount: deposit,
          due: invoceData?.createdAt?.split("T")[0] || "",
        },
        { ...prev[1], amount: balance },
        ...prev.slice(2),
      ]);
    }
  }, [selectedPackagePrice, invoceData?.createdAt]);

  // Fetch Invoice Data
  const fetchInvoiceData = async () => {
    const formData =
      viewType === "view"
        ? {
            Id: selectedInvoice?.Id,
            messageId: selectedConversation?.Id,
            Type: "view",
          }
        : { messageId: selectedConversation?.Id, userId: user?.UserID };

    const response = await orderInvoice(formData);
    setInvoceData(response);
  };

  useEffect(() => {
    if (isOpen) fetchInvoiceData();
  }, [isOpen]);

  // Populate UI from API
  useEffect(() => {
    if (!invoceData) return;

    setDetails({
      clientName: invoceData.customerName || "",
      clientEmail: invoceData.customerEmail || "",
      clientPhone: invoceData.customerPhone || "",
      providerName: invoceData.providerName || "",
      providerAddress: invoceData.providerAddress || "",
      providerEmail: invoceData.providerEmail || "",
      providerPhone: invoceData.providerPhone || "",
    });

    dispatch(setSelectedPrice(invoceData.paymentDetails));
    setDealNote(invoceData.dealNote || "");
    setcollectInsurance(!!invoceData.collectInsurance);
    setEditedPackageIndex(invoceData.editedPackageIndex);
    setPdfFile(invoceData?.invoicePdf || "");
    setInsuranceFile(invoceData?.insuranceFile || "");

    const parse = (field) => {
      try {
        return field ? JSON.parse(field) : [];
      } catch {
        return [];
      }
    };

    const pay = parse(invoceData.paymentDetails);
    if (pay.length) setPaymentSchedule(pay);
    const ev = parse(invoceData.eventDetails);
    if (ev.length) setEvents(ev);
    const sch = parse(invoceData.eventTimeDetails);
    if (sch.length) setEventSchedule(sch);

    const pkg = parse(invoceData.dealPackage);
    if (pkg.length) {
      setInitialDealPackage(pkg);
      dispatch(setInvoiceCreatedPackages(pkg));
    }
    const item = parse(invoceData.dealItem);
    if (item.length) {
      setinitialdealdealItem(item);
      dispatch(setInvoiceItemsToDisplay(item));
    }
    const opt = parse(invoceData.serviceSelectType);
    if (opt.length) {
      setinitialdealserviceSelectType(opt);
      dispatch(setInvoiceOptions(opt));
    }
    const itemC = parse(invoceData.dealItemCustom);
    if (itemC.length) {
      setinitialdealdealItemCustom(itemC);
      dispatch(setNewItemsToDisplay(itemC));
    }
    const optC = parse(invoceData.serviceSelectTypeCustom);
    if (optC.length) {
      setinitialdealserviceSelectTypeCustom(optC);
      dispatch(setNewOptions(optC));
    }

    const contracts = parse(invoceData.contractTerm);
    if (contracts.length) {
      const checkedContracts = contracts.map((c, i) => ({
        ...c,
        checked: i === 0,
      }));
      const filtered = checkedContracts.filter(
        (c) => c.contractType && c.contractDetails
      );
      setContractCheck(filtered);
      setSelectedContract(filtered[0] || {});
    }
  }, [invoceData]);

  // Handlers
  const handleToggleChange = (e) => {
    const isCustom = e.target.checked;
    setChecked(isCustom);
    if (isCustom) {
      dispatch(setNewCreatedPackages(newCreatedPackages));
      dispatch(setNewOptions(initialdealserviceSelectTypeCustom));
      dispatch(setNewItemsToDisplay(initialdealdealItemCustom));
    } else {
      dispatch(setInvoiceCreatedPackages(initialDealPackage));
      dispatch(setInvoiceOptions(initialdealserviceSelectType));
      dispatch(setInvoiceItemsToDisplay(initialdealdealItem));
    }
    dispatch(setSelectedPackages({}));
  };

  const handleCheckboxChange = (e, index) => {
    const updated = contractCheck.map((c, i) => ({
      ...c,
      checked: i === index,
    }));
    setContractCheck(updated);
    setSelectedContract(updated[index]);
  };

  const handleContractTermChange = (e) => {
    const updated = [...contractCheck];
    const idx = updated.findIndex((c) => c.checked);
    if (idx !== -1) updated[idx].contractDetails = e.target.value;
    setContractCheck(updated);
    setSelectedContract(updated[idx]);
  };

  const handleChange = (value, index, field) => {
    const updated = [...events];
    updated[index] = {
      ...updated[index],
      [field]: value instanceof Date ? value.toISOString() : value,
    };
    setEvents(updated);
  };

  const handleScheduleChange = (value, index, field) => {
    const updated = [...eventSchedule];
    updated[index] = { ...updated[index], [field]: value };
    setEventSchedule(updated);
  };

  const handlePayScheduleChange = (value, index, field) => {
    const updated = [...paymentSchedule];
    updated[index] = { ...updated[index], [field]: value };

    if (field === "amount" && index > 1) {
      const total = selectedPackagePrice;
      const deposit = updated[0].amount;
      const paid = updated
        .slice(2)
        .reduce((a, c) => a + (parseInt(c.amount) || 0), 0);
      updated[1].amount = Math.max(total - deposit - paid, 0);
    }
    setPaymentSchedule(updated);
  };

  const handleAddEventSchedule = () => {
    const last = eventSchedule[eventSchedule.length - 1];
    if (
      last.title ||
      last.engage ||
      last.eventStart ||
      last.eventEnd ||
      last.handOver
    ) {
      setEventSchedule((prev) => [
        ...prev,
        { title: "", engage: "", eventStart: "", eventEnd: "", handOver: "" },
      ]);
    }
  };

  const handleAddPaymentSchedule = () => {
    const total = selectedPackagePrice;
    const deposit = paymentSchedule[0].amount;
    const paid = paymentSchedule
      .slice(2)
      .reduce((a, c) => a + (parseInt(c.amount) || 0), 0);
    const remaining = total - deposit - paid;
    const perPayment = Math.floor(remaining / (paymentSchedule.length - 1));
    setPaymentSchedule((prev) => [
      ...prev,
      { payment: "", due: "", amount: perPayment },
    ]);
  };

  const handleRemoveEventSchedule = (i) =>
    setEventSchedule((prev) => prev.filter((_, idx) => idx !== i));
  const handleRemovePaySchedule = (i) =>
    setPaymentSchedule((prev) => prev.filter((_, idx) => idx !== i));

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => setFilePreview(reader.result);
    reader.readAsDataURL(file);
  };

  // PDF Generation (Cloned DOM)
  const generatePdf = async (modalId) => {
    const modal = document.getElementById(modalId);
    const clone = modal.cloneNode(true);
    document.body.appendChild(clone);

    const hide = clone.querySelectorAll(
      ".attach-files, .pencil_Icon, .save-button, .created_Package, .dealFactors, .invoceButton, .invoiceCheckbox, .rsw-toolbar"
    );
    hide.forEach((el) => el.classList.add("d-none"));

    const canvas = await html2canvas(clone, { scale: 2, useCORS: true });
    const imgData = canvas.toDataURL("image/jpeg", 0.8);
    const pdf = new jsPDF("p", "mm", "a4");
    pdf.addImage(imgData, "JPEG", 0, 0, 210, 297);
    pdf.save(`${invoceData.customerName || "Invoice"}.pdf`);

    const blob = pdf.output("blob");
    const file = new File([blob], "invoice.pdf", { type: "application/pdf" });

    document.body.removeChild(clone);
    return viewType === "create" ? await uploadToS3(file, "invoicePdf/") : null;
  };

  // Create Invoice
  const handleCreateInvoice = async () => {
    setLoading(true);
    const invoiceUrl = await generatePdf("my-modal");

    const formData = {
      Id: invoceData.Id || selectedInvoice?.Id,
      messageId: selectedConversation?.Id,
      userId: user?.UserID,
      needName: invoceData?.needName,
      customerName: details.clientName,
      customerPhone: details.clientPhone,
      customerEmail: details.clientEmail,
      providerName: details.providerName,
      providerPhone: details.providerPhone,
      providerEmail: details.providerEmail,
      providerAddress: details.providerAddress,
      eventDetails: JSON.stringify(events.filter((e) => e.eventDate)),
      eventTimeDetails: JSON.stringify(eventSchedule.filter((s) => s.title)),
      paymentDetails: JSON.stringify(paymentSchedule.filter((p) => p.amount)),
      dealPackage: JSON.stringify(invoiceCreatedPackages),
      serviceSelectType: JSON.stringify(invoiceOptions),
      dealItem: JSON.stringify(invoiceItemsToDisplay),
      serviceSelectTypeCustom: JSON.stringify(newOptions),
      dealItemCustom: JSON.stringify(newItemsToDisplay),
      dealNote,
      attachedFile: pdfFile,
      invoicePdf: invoiceUrl,
      insuranceFile,
      collectInsurance,
      editedPackageIndex,
      contractTerm: JSON.stringify(contractCheck),
      updatedBy: user?.UserID,
      Type: "edit",
    };

    await orderInvoice(formData);
    toast.success("Invoice sent successfully!");
    toggleModal();
    setLoading(false);
  };

  const filteredEvents = events.filter((e) => e.eventDate || e.eventLocation);
  const filteredEventSchedule = eventSchedule.filter((s) => s.title);
  const filteredPaySchedule = paymentSchedule.filter((p) => p.amount);

  return (
    <Modal
      id="my-modal"
      isOpen={isOpen}
      toggle={toggleModal}
      size="xl"
      className="invoice-modal"
    >
      <ModalBody className="p-4">
        {/* Header */}
        <Row className="invoice-header mb-1">
          <Col lg={4}>
            <h5 className="fw-bold m-0 p-0">MAJESTIC EVENTS</h5>
            <div className="invoice-title m-0">{invoceData?.needName}</div>
          </Col>
          <Col lg={4} className="text-center">
            <h4 className="invoice-title">INVOICE</h4>
            <small>Invoice ID: {invoceData?.Id}</small>
          </Col>
          <Col lg={4} className="text-end">
            <div>
              Updated{" "}
              {moment(invoceData?.updatedAt || invoceData?.createdAt).format(
                "MM/DD/YYYY"
              )}
            </div>
            <div className="invoice-date">
              {moment(invoceData?.createdAt).format("ddd. MMM. DD, YYYY")}
            </div>
          </Col>
        </Row>
        <div className="invoice-divider my-3" />

        {/* Client & Provider */}
        <Row className="mb-4">
          <Col lg={6}>
            <div className="d-flex align-items-center justify-content-between mb-2">
              <h6 className="section-title">Client Contract</h6>
              {viewType !== "view" && (
                <FaPencilAlt
                  className="edit-icon pencil_Icon"
                  onClick={() => {
                    setEditType("Client Contract");
                    setEditOpen(true);
                  }}
                />
              )}
            </div>
            <div>{details.clientName}</div>
            <div>{details.clientEmail}</div>
            <div>{details.clientPhone}</div>
          </Col>
          <Col lg={6}>
            <div className="d-flex align-items-center justify-content-between mb-2">
              <h6 className="section-title">Provider Contract</h6>
              {viewType !== "view" && (
                <FaRegClipboard
                  className="edit-icon pencil_Icon"
                  onClick={() => {
                    setEditType("Provider Contract");
                    setEditOpen(true);
                  }}
                />
              )}
            </div>
            <div>Majestic Events</div>
            <div>{details.providerName}</div>
            {details.providerAddress && <div>{details.providerAddress}</div>}
            <div>{details.providerEmail}</div>
            <div>{details.providerPhone}</div>
          </Col>
        </Row>

        {/* Tables */}
        <Row className="g-3">
          <Col lg={4}>
            <h6 className="section-title mb-2">Event Details</h6>
            {filteredEvents.length > 0 ? (
              <Table bordered responsive className="invoice-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Time</th>
                    <th>Type</th>
                    <th>Location</th>
                    <th>Guests</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredEvents.map((e, i) => (
                    <tr key={i}>
                      <td>{moment(e.eventDate).format("MMM DD, YYYY")}</td>
                      <td>
                        {e.eventTime &&
                          moment(e.eventTime, "HH:mm").format("hh:mm A")}
                      </td>
                      <td>{e.eventType}</td>
                      <td>{e.eventLocation}</td>
                      <td>{e.totalGuestCount}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <div className="text-center text-muted">No Events</div>
            )}
          </Col>

          <Col lg={4}>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h6 className="section-title">Event Schedule</h6>
              {viewType !== "view" && (
                <FaRegEdit
                  className="edit-icon pencil_Icon"
                  onClick={() => {
                    setEditType("Event Schedule");
                    setEditOpen(true);
                  }}
                />
              )}
            </div>
            {filteredEventSchedule.length > 0 ? (
              <Table bordered responsive className="invoice-table">
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Engage</th>
                    <th>Start</th>
                    <th>End</th>
                    <th>Handover</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredEventSchedule.map((s, i) => (
                    <tr key={i}>
                      <td>{s.title}</td>
                      <td>
                        {s.engage &&
                          moment(s.engage, "HH:mm").format("hh:mm A")}
                      </td>
                      <td>
                        {s.eventStart &&
                          moment(s.eventStart, "HH:mm").format("hh:mm A")}
                      </td>
                      <td>
                        {s.eventEnd &&
                          moment(s.eventEnd, "HH:mm").format("hh:mm A")}
                      </td>
                      <td>
                        {s.handOver &&
                          moment(s.handOver, "HH:mm").format("hh:mm A")}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <div className="text-center text-muted">No Schedule</div>
            )}
          </Col>

          <Col lg={4}>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h6 className="section-title">Payment Schedule</h6>
              {viewType !== "view" && (
                <FaRegEdit
                  className="edit-icon pencil_Icon"
                  onClick={() => {
                    setEditType("Payment Schedule");
                    setEditOpen(true);
                  }}
                />
              )}
            </div>
            {filteredPaySchedule.length > 0 ? (
              <Table bordered responsive className="invoice-table">
                <thead>
                  <tr>
                    <th>Payment</th>
                    <th>Due</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredPaySchedule.map((p, i) => (
                    <tr key={i}>
                      <td>{p.payment}</td>
                      <td>{p.due && moment(p.due).format("MMM DD, YYYY")}</td>
                      <td>${parseInt(p.amount).toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <div className="text-center text-muted">No Payments</div>
            )}
          </Col>
        </Row>

        {/* Package Toggle */}
        <div className="package-toggle text-center my-2">
          <span className="toggle-label-invoice">Select Pre-made Package</span>
          <div className="d-flex align-items-center justify-content-center gap-3">
            <FormControlLabel className="m-0"
              control={
                <Android12Switch
                  checked={checked}
                  onChange={handleToggleChange}
                  disabled={viewType === "view"}
                />
              }
            />
          </div>
          <span className="toggle-label-invoice">Create Custom Package</span>
        </div>

        <DealFactors
          checked={checked}
          state={{ invoice: true }}
          setEditedPackageIndex={setEditedPackageIndex}
          editedPackageIndex={editedPackageIndex}
        />

        {/* Notes & Attachments */}
        <div className="mt-2">
          <h6 className="section-title text-center mb-2">Deal Notes</h6>
          <Input
            type="textarea"
            rows={4}
            value={dealNote}
            onChange={(e) => setDealNote(e.target.value)}
            disabled={viewType === "view"}
          />
          <div className="d-flex justify-content-between align-items-center mt-2">
            <label className="attach-files">
              <IoDocumentAttachSharp /> Attach Files
              <Input
                type="file"
                className="d-none"
                onChange={handleFileChange}
                disabled={viewType === "view"}
              />
            </label>
          </div>
        </div>

        {/* Contract */}
        {contractCheck.length > 0 && (
          <div className="mt-4">
            <h6 className="section-title text-center mb-3">Contract Type</h6>
            <div className="d-flex flex-wrap gap-3 justify-content-center">
              {contractCheck.map((c, i) => (
                <FormControlLabel
                  key={i}
                  control={
                    <Checkbox
                      checked={c.checked}
                      onChange={(e) => handleCheckboxChange(e, i)}
                      disabled={viewType === "view"}
                    />
                  }
                  label={c.contractType + " Contract"}
                  className="contract-checkbox"
                />
              ))}
            </div>
            {selectedContract?.contractDetails && (
              <div className="mt-3">
                <Editor
                  value={selectedContract.contractDetails}
                  onChange={handleContractTermChange}
                  disabled={viewType === "view"}
                />
              </div>
            )}
            <div className="mt-3">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={collectInsurance}
                    onChange={(e) => setcollectInsurance(e.target.checked)}
                    disabled={viewType === "view"}
                  />
                }
                label="Collect insurance record from customer"
              />
            </div>
          </div>
        )}

        {/* Action Button */}
        <div className="text-end mt-2">
          {viewType === "create" ? (
            <Button
              color="success"
              size="sm"
              onClick={handleCreateInvoice}
              disabled={loading}
            >
              {loading ? "Creating..." : "Create Invoice"}
            </Button>
          ) : (
            <Button
              color="primary"
              size="lg"
              onClick={() => generatePdf("my-modal").then(toggleModal)}
            >
              Download Invoice
            </Button>
          )}
        </div>

        {/* Edit Modals */}
        <Modal isOpen={editOpen} toggle={() => setEditOpen(false)} size="lg">
          <ModalBody>
            {/* Client Contract */}
            {editType === "Client Contract" && (
              <div>
                <h4 className="text-center mb-4">Update Client Details</h4>
                <FormGroup>
                  <Label>Client Name</Label>
                  <Input
                    value={details.clientName}
                    onChange={(e) =>
                      setDetails((prev) => ({
                        ...prev,
                        clientName: e.target.value,
                      }))
                    }
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Client Email</Label>
                  <Input
                    type="email"
                    value={details.clientEmail}
                    onChange={(e) =>
                      setDetails((prev) => ({
                        ...prev,
                        clientEmail: e.target.value,
                      }))
                    }
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Client Phone</Label>
                  <Input
                    value={details.clientPhone}
                    onChange={(e) => {
                      const v = e.target.value.replace(/\D/g, "").slice(0, 10);
                      setDetails((prev) => ({ ...prev, clientPhone: v }));
                    }}
                  />
                </FormGroup>
                <div className="text-end mt-3">
                  <Button color="warning" onClick={() => setEditOpen(false)}>
                    Update
                  </Button>
                </div>
              </div>
            )}

            {/* Provider Contract */}
            {editType === "Provider Contract" && (
              <div>
                <h4 className="text-center mb-4">Update Provider Details</h4>
                <FormGroup>
                  <Label>Provider Name</Label>
                  <Input
                    value={details.providerName}
                    onChange={(e) =>
                      setDetails((prev) => ({
                        ...prev,
                        providerName: e.target.value,
                      }))
                    }
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Provider Address</Label>
                  <Input
                    value={details.providerAddress}
                    onChange={(e) =>
                      setDetails((prev) => ({
                        ...prev,
                        providerAddress: e.target.value,
                      }))
                    }
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Provider Email</Label>
                  <Input
                    type="email"
                    value={details.providerEmail}
                    onChange={(e) =>
                      setDetails((prev) => ({
                        ...prev,
                        providerEmail: e.target.value,
                      }))
                    }
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Provider Phone</Label>
                  <Input
                    value={details.providerPhone}
                    onChange={(e) => {
                      const v = e.target.value.replace(/\D/g, "").slice(0, 10);
                      setDetails((prev) => ({ ...prev, providerPhone: v }));
                    }}
                  />
                </FormGroup>
                <div className="text-end mt-3">
                  <Button color="warning" onClick={() => setEditOpen(false)}>
                    Update
                  </Button>
                </div>
              </div>
            )}

            {/* Event Details */}
            {editType === "Event Details" && (
              <div>
                <h4 className="text-center mb-4">Update Event Details</h4>
                {events.map((event, index) => (
                  <Row key={index} className="mb-3">
                    <Col sm={3}>
                      <Label>Event Date</Label>
                      <DatePicker
                        selected={
                          event.eventDate ? new Date(event.eventDate) : null
                        }
                        onChange={(date) =>
                          handleChange(date, index, "eventDate")
                        }
                        className="form-control"
                        dateFormat="MMM dd, yyyy"
                      />
                    </Col>
                    <Col sm={2}>
                      <Label>Time</Label>
                      <Input
                        type="time"
                        value={event.eventTime}
                        onChange={(e) =>
                          handleChange(e.target.value, index, "eventTime")
                        }
                      />
                    </Col>
                    <Col sm={2}>
                      <Label>Type</Label>
                      <Input
                        value={event.eventType}
                        onChange={(e) =>
                          handleChange(e.target.value, index, "eventType")
                        }
                      />
                    </Col>
                    <Col sm={3}>
                      <Label>Location</Label>
                      <Input
                        value={event.eventLocation}
                        onChange={(e) =>
                          handleChange(e.target.value, index, "eventLocation")
                        }
                      />
                    </Col>
                    <Col sm={2}>
                      <Label>Guests</Label>
                      <Input
                        type="number"
                        value={event.totalGuestCount}
                        onChange={(e) =>
                          handleChange(e.target.value, index, "totalGuestCount")
                        }
                      />
                    </Col>
                  </Row>
                ))}
                <div className="text-end">
                  <Button color="warning" onClick={() => setEditOpen(false)}>
                    Update
                  </Button>
                </div>
              </div>
            )}

            {/* Event Schedule */}
            {editType === "Event Schedule" && (
              <div>
                <h4 className="text-center mb-4">Update Event Schedule</h4>
                {eventSchedule.map((event, index) => (
                  <Row key={index} className="mb-3">
                    <Col lg={6}>
                      <Label>Title</Label>
                      <Input
                        value={event.title}
                        onChange={(e) =>
                          handleScheduleChange(e.target.value, index, "title")
                        }
                      />
                      <Label>
                        Engage{" "}
                        <Tooltip title="Time to begin setup">
                          <FaQuestionCircle />
                        </Tooltip>
                      </Label>
                      <Input
                        type="time"
                        value={event.engage}
                        onChange={(e) =>
                          handleScheduleChange(e.target.value, index, "engage")
                        }
                      />
                      <Label>Event End</Label>
                      <Input
                        type="time"
                        value={event.eventEnd}
                        onChange={(e) =>
                          handleScheduleChange(
                            e.target.value,
                            index,
                            "eventEnd"
                          )
                        }
                      />
                    </Col>
                    <Col lg={6}>
                      <Label>Event Start</Label>
                      <Input
                        type="time"
                        value={event.eventStart}
                        onChange={(e) =>
                          handleScheduleChange(
                            e.target.value,
                            index,
                            "eventStart"
                          )
                        }
                      />
                      <Label>Handover</Label>
                      <Input
                        type="time"
                        value={event.handOver}
                        onChange={(e) =>
                          handleScheduleChange(
                            e.target.value,
                            index,
                            "handOver"
                          )
                        }
                      />
                    </Col>
                    <div className="mt-2 text-end">
                      {index === eventSchedule.length - 1 && (
                        <>
                          <Button
                            color="primary"
                            className="me-2"
                            onClick={handleAddEventSchedule}
                          >
                            Add
                          </Button>
                          <Button
                            color="warning"
                            onClick={() => setEditOpen(false)}
                          >
                            Update
                          </Button>
                        </>
                      )}
                      {index > 0 && (
                        <Button
                          color="danger"
                          onClick={() => handleRemoveEventSchedule(index)}
                        >
                          Remove
                        </Button>
                      )}
                    </div>
                  </Row>
                ))}
              </div>
            )}

            {/* Payment Schedule */}
            {editType === "Payment Schedule" && (
              <div>
                <h4 className="text-center mb-4">Update Payment Schedule</h4>
                {paymentSchedule.map((p, i) => (
                  <Row key={i} className="mb-3">
                    <Col lg={4}>
                      <Label>Payment</Label>
                      <Input
                        value={p.payment}
                        onChange={(e) =>
                          handlePayScheduleChange(e.target.value, i, "payment")
                        }
                        disabled={i < 2}
                      />
                    </Col>
                    <Col lg={4}>
                      <Label>Due</Label>
                      <Input
                        type="date"
                        value={p.due}
                        onChange={(e) =>
                          handlePayScheduleChange(e.target.value, i, "due")
                        }
                      />
                    </Col>
                    <Col lg={4}>
                      <Label>Amount</Label>
                      <Input
                        type="number"
                        value={p.amount}
                        onChange={(e) =>
                          handlePayScheduleChange(e.target.value, i, "amount")
                        }
                        disabled={i < 2}
                      />
                    </Col>
                    {i > 1 && (
                      <Button
                        color="danger"
                        className="mt-2"
                        onClick={() => handleRemovePaySchedule(i)}
                      >
                        Remove
                      </Button>
                    )}
                    {i === paymentSchedule.length - 1 && (
                      <div className="text-end mt-2">
                        <Button
                          color="primary"
                          className="me-2"
                          onClick={handleAddPaymentSchedule}
                        >
                          Add
                        </Button>
                        <Button
                          color="warning"
                          onClick={() => setEditOpen(false)}
                        >
                          Update
                        </Button>
                      </div>
                    )}
                  </Row>
                ))}
              </div>
            )}

            {/* Contract Type */}
            {editType === "Contract Type" && (
              <div>
                <h4 className="text-center mb-4">Update Contract Terms</h4>
                <Editor
                  value={selectedContract.contractDetails}
                  onChange={handleContractTermChange}
                />
                <div className="text-end mt-3">
                  <Button color="warning" onClick={() => setEditOpen(false)}>
                    Update
                  </Button>
                </div>
              </div>
            )}

            {/* Collect Insurance */}
            {editType === "Collect Insurance" && (
              <div className="text-center">
                <h4>Upload Proof of Insurance</h4>
                {!filePreview ? (
                  <label className="file-upload-label">
                    <div className="file-upload-design">
                      <h5>Upload proof of insurance coverage</h5>
                      <p>
                        Drag and Drop or{" "}
                        <span className="browse-button">Browse</span>
                      </p>
                    </div>
                    <Input
                      type="file"
                      id="insurance-file"
                      className="d-none"
                      onChange={handleFileChange}
                    />
                  </label>
                ) : (
                  <embed src={filePreview} width="300" height="300" />
                )}
                <Button
                  color="success"
                  className="mt-3"
                  onClick={handleCreateInvoice}
                  disabled={loading}
                >
                  {loading ? "Uploading..." : "Submit & Create Invoice"}
                </Button>
              </div>
            )}
          </ModalBody>
        </Modal>
      </ModalBody>
    </Modal>
  );
};

export default CreateInvoice;
